import { getPageContent } from 'yoda-interfaces/lib/Order/OrderApi';
import get from 'lodash/get';
import { takeLatest, put, call, all, fork, select } from 'redux-saga/effects';
import {
    GET_PLCC_BANNER_HTML,
    SET_PLCC_BANNER_HTML,
    GET_PLCC_DETAILS_HTML,
    SET_PLCC_DETAILS_HTML,
} from '../actionTypes/PlccDynamicBannerActionTypes';

function* setPlccContent(actionParam) {
    const context = (state) => state.context;
    const appContext = yield select(context);
    const { enableCoreMediaContent = true } = appContext?.featureFlags || {};
    const action = actionParam;
    const payload = { pageUrlOrSearchTerm: action.href };
    if (enableCoreMediaContent) {
        payload.isCMHeaderRequired = true;
    }
    if (action?.href?.indexOf('cf-plcc-slide-panel') !== -1) {
        payload.allowMultipleDHTML = true;
    }
    let result = yield call(getPageContent, payload);
    if (result.status === 200) {
        yield all([
            put({
                type: action.successActionType,
                response: get(result, 'data.datas[0].data', undefined),
            }),
        ]);
        /* Retry with IRIS if Coremedia calls fails */
    } else if (enableCoreMediaContent && result.status !== 200) {
        payload.isCMHeaderRequired = false;
        result = yield call(getPageContent, payload);
        yield all([
            put({
                type: action.successActionType,
                response: get(result, 'data.datas[0].data', undefined),
            }),
        ]);
    }
}
function* plccDynamicBannerSaga(actionParam) {
    const action = actionParam;
    action.successActionType = SET_PLCC_BANNER_HTML;
    yield fork(setPlccContent, action);
}

function* plccDynamicBannerDetailsSaga(actionParam) {
    const action = actionParam;
    action.successActionType = SET_PLCC_DETAILS_HTML;
    yield fork(setPlccContent, action);
}
const watchPlccDynamicBannerSaga = function* watchPlccDynamicBannerSaga() {
    yield takeLatest(GET_PLCC_BANNER_HTML, plccDynamicBannerSaga);
    yield takeLatest(GET_PLCC_DETAILS_HTML, plccDynamicBannerDetailsSaga);
};

watchPlccDynamicBannerSaga.sagaName = 'watchPlccDynamicBannerSaga';

export default watchPlccDynamicBannerSaga;
